import app_2 from '@/public/features/price_pages/Frame 1171279152.webp';
import bg from '@/public/features/price_pages/Main.webp';

const intro = {
  tag: '',
  description: `Enhance your business efficiency by organizing, importing, and setting up items in a way that fits your needs. Whether you're managing product inventories or service lists, our Price Pages ensure easy access and management for your team.`,
  imageSrc: bg.src,
  image: bg,
  first_title: 'Organize and Manage Your Items',
  second_title: ' Effortlessly with Our Price Pages',
};

const blog = {
  title: 'Our Blog',
  description: `Dive into a wealth of insights tailored to your industry with Orcatec's blog, your go-to resource 
for the latest trends and tips in service scheduling software free`,
};

const bookDemo = {
  title: `Book a Free Demo`,
  description: `Book a free demo to unlock the full potential of our software for HVAC contractors! Orcatec team is here to guide you. Fill out the form below to receive expert consultation. Don’t miss this opportunity to transform your HVAC business with Orcatec's cutting-edge solutions, specially designed for HVAC contractors!`,
};

const fullArticle2 = {
  image: {
    path: app_2,
    alt: `What are Price Pages?`,
  },
  title: `What are Price Pages?`,
  description: `Price Pages is an essential tool for business owners, allowing you to organize and manage your pricing structures quickly and effectively. This ensures you can handle large inventories, make bulk changes, and customize settings to suit your business operations.`,
  item: [
    {
      title: 'Customizable organization',
      description: `Our system lets you place items in different folders and subfolders to keep everything neatly sorted and easily accessible based on your preferred settings.`,
    },
    {
      title: 'Bulk import/export',
      description: `Easily import and export multiple items at once, saving you time and reducing the potential for errors in data entry.`,
    },
    {
      title: 'Comprehensive item settings',
      description: `Set specific attributes for your items, including marking them as taxable or non-taxable, categorizing them as material or non-material, and adding attachments. This allows for better flexibility and ensures that each item is accurately represented according to your business requirements.`,
    },
  ],
};

export { blog, bookDemo, fullArticle2, intro };
